<template>
  <authorization permissionKey="attendance_glasses_prescription" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Receitas de óculos
        </v-col>

        <authorization
          permissionKey="attendance_glasses_prescription"
          can="save"
          v-slot:default="{ authorization }"
        >
          <v-col cols="auto" v-if="authorization">
            <v-btn
              color="light-blue"
              @click="newGlassesPrescription"
              :dark="!attendanceEsigned"
              :disabled="attendanceEsigned"
            >
              Adicionar
            </v-btn>
          </v-col>
        </authorization>
      </v-row>

      <v-row>
        <v-col>
          <GlassPresciptionList
            :attendance="attendance"
            :allowEdit="!attendanceEsigned"
            :allowDelete="!attendanceEsigned"
          />
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import GlassPresciptionList from "@/components/glasses_prescription/list/index.vue";

  export default {
    name: "GlassesPrescriptions",
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
    components: {
      GlassPresciptionList,
    },
    methods: {
      newGlassesPrescription() {
        this.apolloMutate({
          mutation: require("@/graphql/glasses_prescription/save_glasses_prescription.gql"),
          variables: {
            attendanceId: this.attendance.id,
          },
        }).then(({ data }) => {
          this.$router.push(
            `/prontuario/${this.attendance.id}/receitas-oculos/${data.saveGlassesPrescription.id}`
          );
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
